import React from 'react';

interface VolumeIconProps {
  className?: string;
}

const VolumeIcon: React.FC<VolumeIconProps> = ({ className }) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.5 11.375C1.295 11.375 1.125 11.205 1.125 11C1.125 10.795 1.295 10.625 1.5 10.625H10.5C10.705 10.625 10.875 10.795 10.875 11C10.875 11.205 10.705 11.375 10.5 11.375H1.5Z"
        fill="#FF750B"
      />
      <path
        d="M2 4.18945C1.725 4.18945 1.5 4.41445 1.5 4.68945V8.99945C1.5 9.27445 1.725 9.49945 2 9.49945H2.8C3.075 9.49945 3.3 9.27445 3.3 8.99945V4.68945C3.3 4.40945 3.075 4.18945 2.8 4.18945H2Z"
        fill="#FF750B"
      />
      <path
        d="M5.59961 2.5957C5.32461 2.5957 5.09961 2.8207 5.09961 3.0957V9.0007C5.09961 9.2757 5.32461 9.5007 5.59961 9.5007H6.39961C6.67461 9.5007 6.89961 9.2757 6.89961 9.0007V3.0957C6.89961 2.8207 6.67461 2.5957 6.39961 2.5957H5.59961Z"
        fill="#FF750B"
      />
      <path
        d="M9.2002 1C8.9252 1 8.7002 1.225 8.7002 1.5V9C8.7002 9.275 8.9252 9.5 9.2002 9.5H10.0002C10.2752 9.5 10.5002 9.275 10.5002 9V1.5C10.5002 1.225 10.2752 1 10.0002 1H9.2002Z"
        fill="#FF750B"
      />
    </svg>
  );
};

export default VolumeIcon;